import { useEffect, useRef, useState } from "react";
import { FieldError } from "react-hook-form";
import PhoneCode from "./phoneCodesWithFlag.json";
import i18n from "src/i18n";
type Props = {
  className?: string;
  inputClassName?: string;
  prefixClassName?: string;
  label?: string;
  placeholder?: string;
  type: string;
  name?: string;
  id?: string;
  defaultValue?: string;
  register?: Function;
  validation?: object;
  error?: any;
  errorText?: string;
  onChange?: Function;
  iconUrl?: string;
  onCountryCodeChange?: (code: string) => void;
  disableCountryCode?: boolean;
};

const PhoneInput = ({
  className = "",
  inputClassName = "",
  prefixClassName = "",
  label = "",
  placeholder = "",
  type,
  id = "",
  name = "",
  defaultValue = "",
  register = () => {},
  onChange = () => {},
  validation,
  error,
  errorText = "Please enter a value",
  iconUrl = "",
  onCountryCodeChange = () => {},
  disableCountryCode = false,
}: Props) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const [value, setOptionValue] = useState(defaultValue);
  const [otpionName, setOptionName] = useState<any>();

  const ref = useRef<HTMLInputElement>(null);

  const onClose = (event: any) => {
    setShowDropdown(false);
  };
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose && onClose(event);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  const regResult = typeof register === "function" ? register(name, validation) : undefined;

  return (
    <div
      className={`grid grid-cols-1 mb-4 relative ${className ? className : ""}`}
    >
      {label && (
        <label className="text-xs text-[var(--text-muted)] mb-1">{label}</label>
      )}
      {iconUrl && (
        <img src={iconUrl} alt="start" className="absolute top-3 start-3" />
      )}
      <div className="grid grid-cols-8 gap-4">
        <div className={`relative col-span-3 ${showDropdown && ""}`}>
          <div
            className={`bg-transparent rounded-md outline-none focus:ring-0 text-sm py-3 pb-1.5 px-3 ${!disableCountryCode ? "cursor-pointer" : "cursor-default"} ${prefixClassName} ${
              error ? "border border-danger" : ""
            }`}
            onClick={() => {
              if (!disableCountryCode) setShowDropdown(true);
            }}
          >
            {otpionName ? (
              <span className="inline-flex ps-2">
                <span className="w-8 rounded-full">
                  <img src={`https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/${value}.svg`} alt="flag" className="pe-2" />
                </span>{" "}
                {otpionName}
              </span>
            ) : (
              <span className="inline-flex ps-2">
                <span className="w-8 rounded-full">
                  <img src={`https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/${PhoneCode[228].code}.svg`} alt="flag" className="pe-2" />
                </span>{" "}
                {PhoneCode[228].dial_code}
              </span>
            )}

            {!disableCountryCode && (
              <span className="float-right mt-2">
                <img
                  src="/assets/icons/dropdown_arrow.svg"
                  alt="arrow"
                  className={!showDropdown ? "rotate-180" : ""}
                />
              </span>
            )}
          </div>
          {showDropdown && (
            <div
              className="rounded-lg p-3 absolute bg-[var(--bg-surface-2)] text-[var(--text-main)] z-20 w-full mt-[-150px] top-full h-96 overflow-y-scroll"
              ref={ref}
            >
              {PhoneCode.map((country) => {
                var img = new Image();
                img.src = country.flag;
                return (
                  <div
                    key={country.code}
                    className="px-2 py-2 rounded-md cursor-pointer hover:bg-danger"
                    onClick={() => {
                      setOptionValue(country.code);
                      setOptionName(country.dial_code);
                      onCountryCodeChange(country.dial_code);

                      setShowDropdown(false);
                    }}
                  >
                    <span className="flex">
                      <span className="w-8 rounded-full">
                        <img src={`https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/${country.code}.svg`} alt={`${country.name} flag`} className="pe-2" />
                      </span>{" "}
                      {country.dial_code}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <input
          className={`bg-transparent rounded-md outline-none focus:ring-0 text-sm py-3.5 px-3 col-span-5 ${i18n.language === 'ar' ? 'float-right' : 'float-left'}  ${inputClassName} ${
            iconUrl ? "ps-10" : ""
          } ${error ? "border border-danger" : ""} ${showDropdown && "h-[50px]"}`}
          type={type}
          id={id}
          name={name}
          placeholder={placeholder}
          defaultValue={defaultValue}
          {...regResult}
          onInput={(e: React.ChangeEvent<HTMLInputElement>) => {
            // Remove any character that isn't a digit
            e.target.value = e.target.value.replace(/\D/g, "");
          }}
          onChange={(e: any) => {
            if (regResult && typeof regResult.onChange === "function") {
              regResult.onChange(e);
            }
            if (typeof onChange === "function") {
              onChange(e);
            }
          }}
        ></input>
      </div>
      {error && <p className="mt-1 text-xs text-[var(--color-error)]">{errorText}</p>}
    </div>
  );
};

export default PhoneInput;
